/* Calendly booking modal (non-home pages) */
(function () {
    const modal = document.querySelector('.calendly-modal');
    if (!modal) return;

    const iframe = modal.querySelector('iframe');
    const triggers = document.querySelectorAll('[data-calendly-modal]');

    const openModal = function () {
        // Load Calendly only when first requested, keeping initial page load lean
        if (iframe && !iframe.src) {
            iframe.src = iframe.dataset.src;
        }
        // If triggered from the open mobile menu, close the menu first
        const header = document.querySelector('.site-header.is-open');
        if (header) {
            header.classList.remove('is-open');
            const burger = header.querySelector('.header-burger');
            if (burger) burger.setAttribute('aria-expanded', 'false');
        }
        modal.classList.add('is-open');
        document.documentElement.style.overflowY = 'hidden';
    };

    const closeModal = function () {
        modal.classList.remove('is-open');
        document.documentElement.style.overflowY = null;
    };

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', openModal);
    });

    modal.addEventListener('click', function (e) {
        // Close when clicking the backdrop or the close button, not the panel
        if (!e.target.closest('.calendly-modal-panel') || e.target.closest('.calendly-modal-close')) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
})();

/* Lightbox for the My Story photos — one gallery across every chapter */
(function () {
    const pswpElement = document.querySelector('.pswp');
    const images = document.querySelectorAll('.story-photos img');
    if (!pswpElement || !images.length) return;

    const items = Array.prototype.map.call(images, function (img) {
        const caption = img.closest('figure').querySelector('figcaption');
        return {
            src: img.getAttribute('src'),
            msrc: img.getAttribute('src'),
            w: parseInt(img.getAttribute('width'), 10),
            h: parseInt(img.getAttribute('height'), 10),
            title: caption ? caption.textContent : '',
            el: img,
        };
    });

    const openAt = function (index) {
        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            index: index,
            bgOpacity: 0.92,
            history: false,
            shareEl: false,
            fullscreenEl: false,
            zoomEl: false,
            getThumbBoundsFn: function (i) {
                const rect = items[i].el.getBoundingClientRect();
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            },
        });
        gallery.init();
    };

    images.forEach(function (img, index) {
        // Make each photo reachable and openable from the keyboard
        img.setAttribute('tabindex', '0');
        img.setAttribute('role', 'button');
        img.addEventListener('click', function () {
            openAt(index);
        });
        img.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openAt(index);
            }
        });
    });
})();

/* Mobile menu toggle for the site header */
(function () {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const burger = header.querySelector('.header-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        const isOpen = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.documentElement.style.overflowY = isOpen ? 'hidden' : null;
    });

    // Close the menu after navigating via an in-page anchor (e.g. Book a Call on home)
    header.querySelectorAll('.header-nav a').forEach(function (link) {
        link.addEventListener('click', function () {
            header.classList.remove('is-open');
            burger.setAttribute('aria-expanded', 'false');
            document.documentElement.style.overflowY = null;
        });
    });
})();
